import { getCookie, setCookie, removeCookie } from './cookieUtils';

const TOKEN_KEY = 'auth_token';

class TokenService {
    static setToken(token) {
        // Store token in localStorage for frontend state
        localStorage.setItem('token', token);
        
        // Also set cookie for API requests
        const expires = new Date();
        expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days
        document.cookie = `token=${token};expires=${expires.toUTCString()};path=/;SameSite=Lax${window.location.protocol === 'https:' ? ';Secure' : ''}`;
        
        return true;
    }

    static getToken() {
        // Get token from localStorage for frontend state
        return localStorage.getItem('token');
    }

    static removeToken() {
        // Remove token from localStorage
        localStorage.removeItem('token');
        
        // Remove cookie
        document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
    }

    static isValidToken() {
        const token = this.getToken();
        if (!token) return false;

        try {
            // Check if token is expired
            const payload = JSON.parse(atob(token.split('.')[1]));
            return payload.exp * 1000 > Date.now();
        } catch (error) {
            return false;
        }
    }

    static getAuthHeader() {
        // Get token from cookie for API requests
        const token = this.getToken();
        return token ? { Authorization: `Bearer ${token}` } : {};
    }

    static isValidTokenStructure(token) {
        if (!token) return false;

        try {
            // Check if token has the correct format (header.payload.signature)
            const parts = token.split('.');
            if (parts.length !== 3) {
                return false;
            }

            // Try to decode the payload
            const payload = parts[1];
            const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            // Verify payload is valid JSON
            JSON.parse(jsonPayload);
            return true;
        } catch (error) {
            console.error('Error validating token structure:', error);
            return false;
        }
    }

    static getTokenPayload() {
        try {
            const token = this.getToken();
            if (!token || !this.isValidTokenStructure(token)) {
                return null;
            }

            const payload = token.split('.')[1];
            const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            return JSON.parse(jsonPayload);
        } catch (error) {
            console.error('Error getting token payload:', error);
            return null;
        }
    }
}

export default TokenService; 